import { JobPost } from "../../../api-types/job-posts";
import axios from "../../index";
import { jobPostUrl } from "../../utils";

export const updateJobPost = async (jobPostData: Partial<JobPost>) => {
  return await axios.patch(jobPostUrl(jobPostData?._id ?? ""), jobPostData);
};
